import INTOUCH_API from "../../services/Api";
import Payment from "../../store/Payment";
import { useEffect, useState } from "react";
import PersonalAccount from "../../store/PersonalAccount";

export default function useController() {
  const [link, setLink] = useState("");
  const getInviteLink = () => {
    const order = Payment.getPaymentOrder();
    if (!order) return;
    INTOUCH_API.requestManager(
      "invite_link",
      { payload: { order } },
      (response) => {
        setLink(response.data.link.link);
      },
      (error) => {}
    ).finally(() => {});
  };
  const onLinkCopyHandle = () => {
    if (PersonalAccount.timerLinksMap.length) {
      const prevTimer = PersonalAccount.timerLinksMap.shift();
      clearInterval(prevTimer);
    }
    PersonalAccount.addTimer(
      setInterval(async () => {
        getInviteLink();
      }, 2000)
    );
  };
  useEffect(() => {
    getInviteLink();
  }, []);
  return {
    link,
    onLinkCopyHandle,
  };
}
